// src/task/TaskCard.js
import React from 'react';
import { Star, User } from 'lucide-react';

const statusLabels = {
  '1': { label: 'En attente', bg: 'bg-blue-100', text: 'text-blue-800' },
  '2': { label: 'En cours', bg: 'bg-amber-100', text: 'text-amber-800' },
  '3': { label: 'Prêt', bg: 'bg-green-100', text: 'text-green-800' },
};

const TaskCard = ({
  id,
  title,
  content,
  priorite,
  etape,
  type,
  status,
  createur,
  deadlineClient,
  deadlineTech,
  developpeurs,
  isMobile
}) => {
  const renderStars = (rating) =>
    Array.from({ length: 3 }, (_, index) => (
      <Star
        key={index}
        className={`w-3 h-3 ${index < rating ? 'fill-amber-600 text-amber-600' : 'text-gray-300'}`}
      />
    ));

  const getMainDeveloper = () => {
    if (developpeurs && developpeurs.length > 0) {
      return developpeurs[0];
    }
    return null;
  };

  const getCardBackgroundColor = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Réinitialiser l'heure pour la comparaison
    
    // Vérifier si le ticket est dans les étapes 1, 2 ou 3
    if ([1, 2, 3].includes(Number(etape))) {
        // Si étape 3 avec status 1 ou 2, ou toute autre étape (1 ou 2)
        if ((Number(etape) === 3 && [1, 2].includes(Number(status))) || [1, 2].includes(Number(etape))) {
            if (deadlineTech) {
                const deadlineDate = new Date(deadlineTech);
                deadlineDate.setHours(0, 0, 0, 0); // Réinitialiser l'heure pour la comparaison
                
                if (deadlineDate.getTime() === today.getTime()) {
                    // Deadline tech = aujourd'hui -> jaune froid
                    return 'bg-yellow-100 border-yellow-300';
                } else if (deadlineDate < today) {
                    // Deadline tech dépassée -> rouge froid
                    return 'bg-red-100 border-red-300';
                }
            }
        }
    }
    
    // Couleur par défaut
    return 'bg-white border-gray-200';
};

  const mainDeveloper = getMainDeveloper();

  return (
    <div className={`${getCardBackgroundColor()} border p-2 mb-2 rounded-md shadow-sm hover:shadow-md transition-all duration-200 hover:border-terracotta/30 overflow-hidden`}>
      <div className="flex items-start justify-between mb-1">
        <div className="flex-1 min-w-0">
          <div className={`${isMobile ? 'text-[9px]' : 'text-[10px]'} text-gray-500 mb-0.5`}>#{id}</div>
          <h3 className={`${isMobile ? 'text-xs' : 'text-sm'} font-semibold text-gray-800 truncate`}>{title}</h3>
        </div>
        <div className="flex items-center gap-1 ml-2">
          <div className="flex items-center gap-0.5">
            {renderStars(Number(priorite))}
          </div>
        </div>
      </div>

      <p className={`${isMobile ? 'text-[10px]' : 'text-[11px]'} text-gray-600 mb-2 truncate leading-snug`}>{content}</p>

      <div className="flex items-center justify-between text-[10px] font-medium mb-1">
        <span
          className={`${statusLabels[status]?.bg || 'bg-gray-100'} ${statusLabels[status]?.text || 'text-gray-600'} rounded-full px-1 py-0.5`}
        >
          {statusLabels[status]?.label || status}
        </span>
        
        {developpeurs && developpeurs.length > 0 && (
          <div className="flex items-center gap-1">
            {developpeurs.slice(0, 3).map((dev, index) => (
              <div key={index} className="relative group">
                <div className={`${isMobile ? 'w-3 h-3 text-[6px]' : 'w-4 h-4 text-[8px]'} rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold border border-gray-300`}>
                  {(dev.nom?.charAt(0) || '').toUpperCase()}
                  {(dev.prenom?.charAt(0) || '').toUpperCase()}
                </div>
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 bg-gray-800 text-white text-[9px] rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                  {dev.nom} {dev.prenom}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-l-transparent border-r-transparent border-t-gray-800"></div>
                </div>
              </div>
            ))}
            {developpeurs.length > 3 && (
              <span className={`${isMobile ? 'text-[7px]' : 'text-[8px]'} text-gray-500 bg-gray-100 px-1 py-0.5 rounded`}>
                +{developpeurs.length - 3}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="pt-1 border-t border-gray-100 text-[10px] text-gray-600">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <span className="font-medium text-gray-500">Deadline:</span>
            <span className={new Date(deadlineClient) < new Date() ? 'text-red-500' : ''}>
              {deadlineClient}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <span>{type}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskCard;